import { useEffect } from "react";
import dayjs from "dayjs";
import { DateRange } from "@/components/dateRange";
import { useDatatableContext } from "@/components/tables/contexts/DatatableContextProvider";
import useFiltersBySearchParams from "@/helpers/useFiltersBySearchParams";

const GroupsDateRange = () => {
  const { getFilterValue, registerFilters } = useDatatableContext();
  const { updateSearchParamsByKey } = useFiltersBySearchParams();

  const defaultDays = 28;

  // Register date filters
  useEffect(() => {
    registerFilters({
      start_date: {
        label: "Start Date",
        defaultValue: dayjs().subtract(defaultDays, "day").toDate(),
      },
      end_date: {
        label: "End Date",
        defaultValue: dayjs().toDate(),
      },
    });
  }, [registerFilters, defaultDays]);

  // Get current date filters (handle both Date objects and ISO strings from search params)
  const startDateValue = getFilterValue("start_date");
  const endDateValue = getFilterValue("end_date");

  const startDate = startDateValue
    ? startDateValue instanceof Date
      ? startDateValue
      : new Date(startDateValue as string)
    : dayjs().subtract(defaultDays, "day").toDate();

  const endDate = endDateValue
    ? endDateValue instanceof Date
      ? endDateValue
      : new Date(endDateValue as string)
    : dayjs().toDate();

  const handleDateRangeSelect = (newStartDate: Date | null, newEndDate: Date | null) => {
    if (newStartDate && newEndDate) {
      updateSearchParamsByKey({
        start_date: newStartDate.toISOString(),
        end_date: newEndDate.toISOString(),
      });
    }
  };

  return (
    <DateRange
      variant="inline"
      startDate={startDate}
      endDate={endDate}
      availableStaticRanges={["Last day", "Last 7 days", "Last 28 days"]}
      disableCalendarSelection
      onDateRangeSelect={handleDateRangeSelect}
    />
  );
};

export default GroupsDateRange;
